import wnumb from 'wnumb'


const PriceFormatter = {

	formatter: null,


	formatToPrice( value ) {
		return this.getPriceFormatter().to( value )
	},

	formatToFloat( value ) {
		return this.getPriceFormatter().from( value )
	},

	getPriceFormatter() {
		if( null === this.formatter ) {
			this.formatter = wnumb({
				decimals: 	2,
				mark: 		'.',
				prefix: 	'$',
				thousand: 	',',
			})
		}

		return this.formatter
	}

}


export default PriceFormatter
